<template>
  <v-card elevation="2" outlined tile>
      <v-card-title><v-icon>{{ icon }}</v-icon>{{ title }}</v-card-title>
    <v-card-text>
      <v-progress-linear height="25" :value="stats.progress" striped>
        {{ stats.completed }}/{{ stats.total }} ({{ stats.progress }}%)
      </v-progress-linear>
    </v-card-text>
  </v-card>
</template>

<script>

export default {
  name: "GenericProgressLinear",
  props: ['title' , 'icon', 'stats']
};
</script>

<style scoped>
.v-card__title > .v-icon {
  margin-right: 10px;
}
</style>
